export default [
    {
        label: "checked",
        value: true
    },{
        label: "unchecked",
        value: false
    }
]


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/options/check-options.ts